import { useAuth } from "@/contexts/AuthContext";
import { useToast } from "@/components/ui/use-toast";
import { supabase } from "@/integrations/supabase/client";
import { STRIPE_PRICE_IDS } from "@/constants/pricing";

export const useSubscription = () => {
  const { user } = useAuth();
  const { toast } = useToast();

  const handleSubscribe = async (priceId: string = STRIPE_PRICE_IDS.MONTHLY) => {
    
    if (!user) {
      toast({
        title: "Sign in required",
        description: "Please sign in to subscribe.",
        variant: "destructive",
      });
      return;
    }

    try {
      const { data, error } = await supabase.functions.invoke(
        "create-checkout-session",
        {
          body: { 
            priceId,
            successUrl: `${window.location.origin}/dashboard`,
            cancelUrl: `${window.location.origin}/`,
          },
        }
      );

      if (error) {
        throw error;
      }

      if (data?.url) {
        window.location.href = data.url;
      } else {
        throw new Error('No checkout URL received');
      }
    } catch (error: any) {
      let errorMessage = 'Something went wrong';
      const edgeError = (error as any)?.context?.error || (error as any)?.error || (error as any);
      if (edgeError) {
        if (typeof edgeError === 'string') {
          errorMessage = edgeError;
        } else if (edgeError.message) {
          errorMessage = edgeError.message;
        }
      }

      toast({
        title: "Error",
        description: errorMessage,
        variant: "destructive",
      });
    }
  };

  // Convenience methods for specific plans
  const handleSubscribeMonthly = () => handleSubscribe(STRIPE_PRICE_IDS.MONTHLY);
  const handleSubscribeAnnually = () => handleSubscribe(STRIPE_PRICE_IDS.ANNUAL);

  return { 
    handleSubscribe,
    handleSubscribeMonthly,
    handleSubscribeAnnually,
    PRICE_IDS: STRIPE_PRICE_IDS
  };
};